import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
// Import Bootstrap an BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import Vuelidate from "vuelidate";
import VueAxios from "vue-axios";
import VueDOMPurifyHTML from "vue-dompurify-html";

import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";
import store from "./store";
import axios from "@/utils/axios.js";
import "./components";
import servicePlugin from "@/plugins/service.js";
import Service from "@/utils/service.js";

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(VueAxios, axios);
Vue.use(Vuelidate);
Vue.use(VueDOMPurifyHTML, {
  namedConfigurations: {
    plaintext: {
      USE_PROFILES: { html: false }
    }
  }
});

Vue.use(servicePlugin, new Service(axios));

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
